export default { 'Content-Type': 'application/json' };
